module.exports = __webpack_public_path__ + "static/img/rank_237.871bd39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_237.png
// module id = 5bmB
// module chunks = 0